import stylesButtonBase from '@fukku/button/Base/ButtonBase.module.css'
import textBodyLinkM from '@fukku/styles/texts/textBodyLinkM.module.css'
import textBodyLinkS from '@fukku/styles/texts/textBodyLinkS.module.css'
import { cx } from 'classix'
import { ButtonBase } from '../Base/ButtonBase'
import { BUTTON_VARIANT } from '../Button.types'
import styles from './ButtonContentLink.module.css'

export enum LINK_SIZE {
	S = 'small',
	M = 'medium',
}

export interface ContentLinkProps extends React.ComponentProps<'button'> {
	readonly size?: LINK_SIZE
	readonly variant?: BUTTON_VARIANT
	readonly href?: string
	readonly target?: string
	readonly rel?: string
}

export function ButtonContentLink(props: ContentLinkProps): React.ReactNode {
	const {
		children,
		variant = BUTTON_VARIANT.DEFAULT,
		size = LINK_SIZE.M,
		className,
		href,
		target,
		rel,
		...rest
	} = props

	const textStyle =
		size === LINK_SIZE.S ? textBodyLinkS.className : textBodyLinkM.className

	if (href) {
		return (
			<a
				href={href}
				target={target}
				rel={rel}
				className={cx(
					stylesButtonBase.button,
					styles[variant],
					styles[size],
					textStyle,
					className
				)}
			>
				{children}
			</a>
		)
	}

	return (
		<ButtonBase
			{...rest}
			className={cx(styles[variant], styles[size], textStyle, className)}
		>
			{children}
		</ButtonBase>
	)
}
